// extracted by mini-css-extract-plugin
module.exports = {"container":"doc-breadcrumb_container__l80u_","breadcrumb":"doc-breadcrumb_breadcrumb__xyMjK"};